<template>
    <div class="row" >
        <div class="col-md-12">

            <div class="row">
                <div class="col-md-12">
                    <div class="card">

                        <div class="card-body">

                            <div class="row">
                                <div class="col-md-4" v-if="valuesIn.name">
                                    <div><span>Naam: {{valuesIn.name}}</span><br></div>
                                    <div v-if="!valuesIn.parent.value"><span >Vak: {{valuesIn.course.text}}</span><br></div>
                                    <div v-if="!valuesIn.parent.value"><span>{{$t('group.school_year')}}: {{valuesIn.season.text}}</span></div>
                                    <div v-if="!valuesIn.parent.value"><span>Start: {{valuesIn.start}}</span></div>
                                    <div v-if="!valuesIn.parent.value"><span>{{$t('group.end')}}: {{valuesIn.end}}</span></div>
                                    <div v-if="!valuesIn.parent.value && valuesIn.type"><span>Type: {{valuesIn.type.text}}</span></div>
                                    <div v-if="!valuesIn.parent.value && valuesIn.editor"><span>Editor: {{valuesIn.editor.text}}</span></div>
                                    <div v-if="!valuesIn.parent.value && valuesIn.portfolio_group_copy"><span>Portfolio kopie van: {{valuesIn.portfolio_group_copy}}</span></div>

                                </div>

                                <div class="offset-md-2 col-md-5">

                                    <div class="row options-row">
                                        <div class="col-md-10"><label>Agenda</label></div>
                                        <div class="col-md-2">
                                            <b-form-checkbox
                                                    v-model="questions.options.values.agenda"
                                                    name="group-option-agenda"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch
                                            ></b-form-checkbox>
                                        </div>
                                    </div>

                                    <div class="row options-row">
                                        <div class="col-md-10"><label>{{$t('group.messages')}}</label></div>
                                        <div class="col-md-2">
                                            <b-form-checkbox
                                                    v-model="questions.options.values.messages"
                                                    name="group-option-agenda"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch
                                            ></b-form-checkbox>
                                        </div>
                                    </div>

                                    <div class="row options-row" v-if="hasFiles">
                                        <div class="col-md-10"><label>{{$t('group.documents')}}</label></div>
                                        <div class="col-md-2">
                                            <b-form-checkbox
                                                    v-model="questions.options.values.files"
                                                    name="group-option-agenda"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch
                                            ></b-form-checkbox>
                                        </div>
                                    </div>

                                    <div class="row options-row">
                                        <div class="col-md-10"><label>{{$t('group.source_list')}}</label></div>
                                        <div class="col-md-2">
                                            <b-form-checkbox
                                                    v-model="questions.options.values.sources"
                                                    name="group-option-agenda"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch
                                            ></b-form-checkbox>
                                        </div>
                                    </div>

                                    <div class="row options-row">
                                        <div class="col-md-10"><label>{{$t('group.log')}}</label></div>
                                        <div class="col-md-2">
                                            <b-form-checkbox
                                                    v-model="questions.options.values.logbook"
                                                    name="group-option-agenda"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch
                                            ></b-form-checkbox>
                                        </div>
                                    </div>

                                    <div class="row options-row" v-if="hasPowerpoint">
                                        <div class="col-md-10"><label>Powerpoint</label></div>
                                        <div class="col-md-2">
                                            <b-form-checkbox
                                                    v-model="questions.options.values.powerpoint"
                                                    name="group-option-agenda"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch
                                            ></b-form-checkbox>
                                        </div>
                                    </div>

                                    <div class="row options-row" v-if="hasPlagiarism">
                                        <div class="col-md-10"><label>{{$t('group.plagiarism')}}</label></div>
                                        <div class="col-md-2">
                                            <b-form-checkbox
                                                    v-model="questions.options.values.plagiarism"
                                                    name="group-option-agenda"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch
                                            ></b-form-checkbox>
                                        </div>
                                    </div>

                                    <div class="row options-row">
                                        <div class="col-md-10"><label>{{$t('group.roadmap')}}</label></div>
                                        <div class="col-md-2">
                                            <b-form-checkbox
                                                    v-model="questions.options.values.roadmap"
                                                    name="group-option-agenda"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch
                                            ></b-form-checkbox>
                                        </div>
                                    </div>

                                    <div class="row options-row">
                                        <div class="col-md-10"><label>{{$t('group.assessment_form')}}</label></div>
                                        <div class="col-md-2">
                                            <b-form-checkbox
                                                    v-model="questions.options.values.rating"
                                                    name="group-option-agenda"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch
                                            ></b-form-checkbox>
                                        </div>
                                    </div>

                                    <div class="row options-row" v-if="hasActionplan">
                                        <div class="col-md-10"><label>{{$t('group.plan_of_approach')}}</label></div>
                                        <div class="col-md-2">
                                            <b-form-checkbox
                                                    v-model="questions.options.values.actionplan"
                                                    name="group-option-agenda"
                                                    value="1"
                                                    size="5"
                                                    unchecked-value="0"
                                                    switch
                                            ></b-form-checkbox>
                                        </div>
                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "design-2021-group-create-tab-options-component",
        props: ['valuesIn'],
        data () {
            return {
                valid: true,
                currentQuestion: null,
                questions: {
                    options: {
                        values: {
                            agenda: 1,
                            messages: 1,
                            files: 1,
                            sources: 1,
                            logbook: 1,
                            powerpoint: 1,
                            plagiarism: 1,
                            roadmap: null,
                            rating: null,
                            actionplan: null
                        },
                        live: false,
                        passed: false
                    }
                }
            }
        },
        methods: {
            next() {
                return this.questions.options.values
            },
            previous() {
                this.$emit('disable-finish');
                return true;
            }
        },
        computed: {
            hasPlagiarism () {
                return  !(!this.valuesIn.type || this.valuesIn.type.value === 2 || this.valuesIn.type.value === 5);
            },
            hasPowerpoint () {
                return  !(!this.valuesIn.type || this.valuesIn.type.value === 2 || this.valuesIn.type.value === 5);
            },
            hasActionplan() {
                return !(!this.valuesIn.type || this.valuesIn.type.value === 2);
            },
            hasFiles() {
                return !(!this.valuesIn.type || this.valuesIn.type.value === 2);
            }
        }
    }
</script>

<style scoped>
    .options-row {
        margin-bottom: 10px;
    }

</style>
